var GallerySwiper = class extends HTMLElement {

    constructor() {
        super();
        if (window.matchMedia("(max-width: 999px)").matches) {
            this.initSwiper();
        }
    }

    initSwiper() {
        const swiper = new Swiper('.swiper', {
            // Optional parameters
            loop: true,

            // And if we need scrollbar
            scrollbar: {
                el: '.swiper-scrollbar',
            },
        });

    };
}
window.customElements.define("gallery-swiper", GallerySwiper);
